import React from 'react';
import Modal from '../Modal';

import { ReactComponent as TrashIcon } from '../images/trash.svg';

const RulesTable = ({ rules, handleClick, handleDelete }) => {
  const getRuleString = (rule) => {
    try {
      const obj = JSON.parse(rule);

      const key = Object.keys(obj)[0];
      const value = obj[key];

      if (key === 'utm_source_in') {
        return 'utm source in [' + value.join(', ') + ']';
      }
      else if (key === 'utm_campaign_in') {
        return 'utm campaign in [' + value.join(', ') + ']';
      }
      else if (key === 'utm_term_in') {
        return 'utm term in [' + value.join(', ') + ']';
      }
      else if (key === 'ip_in') {
        return 'ip in [' + value.join(', ') + ']';
      }
      else {
        return 'some other condition';
      }
    }
    catch (e) {
      return '';
    }
  }

  return (
    <div
      style={{
        height: '200px',
        overflowY: 'auto',
        border: '1px solid #333',
        borderRadius: '6px',
      }}>

      <style>
        {`
      .rules-table tr:hover {
        background-color: #333;   /* highlight color */
        cursor: pointer;             /* optional */
      }
    `}
      </style>

      <table className="rules-table"
             style={{
               width: '100%',
               borderCollapse: 'collapse',
               tableLayout: 'fixed',
               fontFamily: 'sans-serif',
               fontSize: '14px',
             }}>
        <colgroup>
          <col style={{ width: '30%' }} />
          <col style={{ width: '35%' }} />
          <col style={{ width: '30%' }} />
          <col style={{ width: '5%' }} />
        </colgroup>
        <thead>
          <tr>
            <th
              style={{
                textAlign: 'left',
                padding: '8px',
                borderBottom: '1px solid #333',
                background: '#333',
              }}>
              Name
            </th>
            <th
              style={{
                textAlign: 'left',
                padding: '8px',
                borderBottom: '1px solid #333',
                background: '#333',
              }}>
              When
            </th>
            <th
              style={{
                textAlign: 'left',
                padding: '8px',
                borderBottom: '1px solid #333',
                background: '#333',
              }}>
              Action
            </th>
            <th
              style={{
                textAlign: 'left',
                padding: '8px',
                borderBottom: '1px solid #333',
                background: '#333',
              }}>
            </th>
          </tr>
        </thead>
        <tbody>
          {rules.map((rule, idx) => (
            <tr key={rule.name || idx}>
              <td
                style={{
                  padding: '8px',
                  borderBottom: '1px solid #333',
                  verticalAlign: 'top',
                  wordWrap: 'break-word',
                }}
                onClick={() => handleClick(idx)}>
                {rule.name}
              </td>
              <td
                style={{
                  padding: '8px',
                  borderBottom: '1px solid #333',
                  fontFamily: 'monospace',
                  whiteSpace: 'pre-wrap',
                  wordWrap: 'break-word',
                }}
                onClick={() => handleClick(idx)}>
                {getRuleString(rule.when)}
              </td>
              <td
                style={{
                  padding: '8px',
                  borderBottom: '1px solid #333',
                  fontFamily: 'monospace',
                  whiteSpace: 'pre-wrap',
                  wordWrap: 'break-word',
                }}
                onClick={() => handleClick(idx)}>
                {rule.action}
              </td>
              <td
                style={{
                  padding: '8px',
                  borderBottom: '1px solid #333',
                  verticalAlign: 'top',
                  wordWrap: 'break-word',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(idx);
                }}>
                <TrashIcon className='image'
                           style={{width: '15px',
                                   height: '15px',
                                   fill: 'white',
                                   cursor: 'pointer',
                                  }} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default RulesTable;
